export default "__VITE_ASSET__a007f8e5__"